module.exports = require("es6-promise");


//////////////////
// WEBPACK FOOTER
// external "es6-promise"
// module id = 174
// module chunks = 0